import './App.css';
import Main from './containers/home/Main'

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
